function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import Icon from '../icon';
import Text from '../text';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var IconAndText = function IconAndText(_ref) {
  var Tag = _ref.asTag,
      allowi18nhtml = _ref.allowi18nhtml,
      className = _ref.className,
      children = _ref.children,
      content = _ref.content,
      textClassName = _ref.textClassName,
      others = _objectWithoutProperties(_ref, ["asTag", "allowi18nhtml", "className", "children", "content", "textClassName"]);

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, {
    className: classNames('icon-and-text', className)
  }, React.createElement(Icon, _extends({
    name: true,
    className: className
  }, others)), content && allowi18nhtml ? React.createElement(IconAndText.Text, {
    className: textClassName,
    dangerouslySetInnerHTML: {
      __html: content
    }
  }) : React.createElement(IconAndText.Text, {
    className: textClassName
  }, content || children)));
};

IconAndText.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  content: PropTypes.any,
  children: PropTypes.any,
  allowi18nhtml: PropTypes.bool,
  textClassName: PropTypes.string,
  asTag: PropTypes.string
};
IconAndText.defaultProps = {
  asTag: 'p'
};
IconAndText.Text = Text;
export default withModifiers(IconAndText);